export default __webpack_public_path__ + "static/media/arrow-up.6985456d.svg";